<template>
  <div>
    <DescriptionCard />
    <BarChart
      class="margin-bottom-16 width-percent-100"
      :labels="labels"
      :series="barChartSeries"
      type="column"
      :titleText="$lang.cumulativeChart"
    />
    <ParvandehCard>
      <template slot="left-col" slot-scope="{ item }">
        <TinyAverageBarBox
          :modalTitle="$lang.comparativeChart"
          :labels="labels"
          :splineSeries="generateTinyAverageBarSeries(item)"
          :averageBarLabels="generateAverageBarLabels(item)"
          :averageBarSeries="generateAverageBarSeries(item)"
          :radarLabels="generateAverageBarLabels(item)"
          :radarSeries="generateRadarSeries(item)"
          :radarYAxisRange="generateRadarYAxisSeries(item)"
          :yAxisMaxAverageBarChart="100"
          :yAxisMin="0"
          :yAxisMax="100"
        />
      </template>
      <template slot="body" slot-scope="{ item }">
        <b-row class="margin-0">
          <b-col cols="12" class="font-size-14 color-complementary-400">
            <PercentTableWrapper :data="item"> </PercentTableWrapper>
          </b-col>
        </b-row>
      </template>
    </ParvandehCard>
  </div>
</template>

<script>
import { Bar as BarChart } from "@/components/charts";
import DescriptionCard from "../components/DescriptionCard.vue";
import ParvandehCard from "../components/parvandeh-card/ParvandehCard.vue";
import PercentTableWrapper from "../components/percent-table/PercentTableWrapper.vue";
import TinyAverageBarBox from "../components/TinyAverageBarBox.vue";
import { computed, inject, onMounted, ref, watch } from "vue";
import { pathOr, includes } from "ramda";
import { generateLang, range } from "@/shared/utils";
export default {
  components: {
    BarChart,
    DescriptionCard,
    ParvandehCard,
    PercentTableWrapper,
    TinyAverageBarBox,
  },
  setup() {
    const tabs = [
      {
        text: generateLang(["barChart"]),
      },
      {
        text: generateLang(["radarChart"]),
      },
    ];
    const currentTab = inject("CURRENT_TAB");
    const algorithmName = computed(() =>
      pathOr(null, ["algorithmName"], currentTab.value)
    );
    const firstTabTitle = computed(() =>
      pathOr(null, ["firstTabTitle"], currentTab.value)
    );
    const parvandehItems = inject("PARVANDEH_ITEMS");
    const averageParentData = inject("AVERAGE_PARENT_DATA");
    const averageChildData = inject("AVERAGE_CHILD_DATA");
    const getDashboardReportData = inject("GET_DASHBOARD_REPORT_DATA");
    onMounted(() => getDashboardReportData(algorithmName.value));
    watch(algorithmName, () => getDashboardReportData(algorithmName.value));

    const ExpandedChartItems = ref([]);
    const handleOpenExpandedChartModal = (code) =>
      ExpandedChartItems.value.push(code);
    const handleCloseExpandedChartModal = (code) => {
      const index = ExpandedChartItems.value.findIndex(
        (codeItem) => codeItem === code
      );

      if (index !== -1) {
        ExpandedChartItems.value.splice(index, 1);
      }
    };

    // generate charts data
    const labels = computed(() =>
      parvandehItems.value.map(({ fullName }) => fullName)
    );
    const barChartSeries = computed(() => {
      const data = parvandehItems.value.map((item) => {
        const insideItems = pathOr([], ["parent", "items"], item);
        return pathOr(0, ["0", "rank_percent"], insideItems);
      });

      return [
        {
          data,
          showInLegend: false,
          name: "بازده انتظاری",
        },
        {
          data: averageParentData.value,
          showInLegend: false,
          name: "میانگین",
          type: "spline",
        },
      ];
    });
    const generateAverageBarLabels = (item) => {
      const items = pathOr([], ["children", "0", "items"], item);
      return items.map((item) => pathOr("", ["title"], item));
    };
    const generateAverageBarSeries = (item) => {
      const items = pathOr([], ["children", "0", "items"], item);
      const data = items.map((item) => pathOr(0, ["rank_percent"], item));
      return [
        {
          data,
          showInLegend: true,
          name: "شایستگی",
          type: "column",
        },
        {
          data: averageChildData.value,
          showInLegend: true,
          name: "میانگین هر شاخص",
          type: "spline",
        },
      ];
    };
    const generateTinyAverageBarSeries = (item) => {
      const items = pathOr([], ["children", "0", "items"], item);
      const data = items.map((item) => pathOr(0, ["rank_percent"], item));
      return [
        {
          data,
          type: "column",
        },
        {
          data: averageChildData.value,
          type: "spline",
        },
      ];
    };
    const generateRadarSeries = (item) => {
      const items = pathOr([], ["children", "0", "items"], item);
      const data = items.map((item) => pathOr(0, ["rank_percent"], item));
      return [
        { type: "area", showInLegend: true, name: "شایستگی", data },
        {
          type: "area",
          data: averageChildData.value,
          showInLegend: true,
          name: "میانگین هر شاخص",
        },
      ];
    };
    const generateRadarYAxisSeries = (item) => {
      const items = pathOr([], ["children", "0", "items"], item);
      return items.map((item, index) => index + 1);
    };

    return {
      tabs,
      labels,
      ExpandedChartItems,
      handleOpenExpandedChartModal,
      handleCloseExpandedChartModal,
      barChartSeries,
      generateAverageBarLabels,
      generateAverageBarSeries,
      generateTinyAverageBarSeries,
      includes,
      generateRadarSeries,
      generateRadarYAxisSeries,
      firstTabTitle,
      range,
    };
  },
};
</script>

<style>
.table-grid-row {
  display: grid;
  grid-template-rows: auto;
  align-items: start;
}
.table-body {
  min-width: 1200px;
}
</style>
